// <purpose>Generated Sachbearbeiter instruction (E1/E3, leadership brief): status_kurz badge +
// Warum/Was-tun lines + optional „Fehlt:" chip. Renders on EVERY engine ticket — above the
// letter editor on drafted tickets, inside NoDraftCard's explanation slot on no-drafts — so the
// clerk field is never blank. Internal text only, never customer-facing.</purpose>
// <dependencies>ClerkInstruction from types (camelCase wire DTO); theme tokens.</dependencies>
// <constraints>Presentational + fetch-static: all content arrives with the ticket detail, so the
// panel never appears/resizes after mount (UI Layout Stability). Callers own the null fallback
// (NoDraftCard renders static copy; drafted tickets simply omit the panel).</constraints>
import React from 'react';
import { ClerkInstruction } from '../types';
import { theme } from '../theme';
import { neutralPillStyle } from './SecondaryAxisPills';

const ClerkInstructionPanel: React.FC<{ instruction: ClerkInstruction }> = ({ instruction }) => (
  <div style={{
    padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
    backgroundColor: theme.colors.bgPage,
    border: `1px solid ${theme.colors.borderLight}`,
    borderRadius: theme.borderRadius.md,
    fontSize: 13, lineHeight: 1.6, color: theme.colors.navyMid,
  }}>
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: theme.spacing.xs, marginBottom: theme.spacing.xs }}>
      <span style={{
        fontSize: 11, fontWeight: 600, padding: '2px 10px', borderRadius: 10,
        color: theme.colors.navy, backgroundColor: theme.colors.white,
        border: `1px solid ${theme.colors.borderLight}`,
      }}>{instruction.statusKurz}</span>
      {instruction.fehltKonkret && (
        // Same neutral-pill shape as TicketRowMeta's row chips (not secondary-axis, just the
        // shared factory) — was a third hand-rolled copy of the identical object before this
        // collapse; picks up flexShrink:0 from the factory, which this copy never had, so it wraps
        // to the next line under `flexWrap` above rather than compressing under a narrow panel.
        <span style={neutralPillStyle('row')}>Fehlt: {instruction.fehltKonkret}</span>
      )}
    </div>
    <div><span style={{ fontWeight: 600 }}>Warum:</span> {instruction.warum}</div>
    <div><span style={{ fontWeight: 600 }}>Was tun:</span> {instruction.wasTun}</div>
  </div>
);

export default ClerkInstructionPanel;
